import { i18n } from '@/plugins'

export const ARRIVAL_TYPE = {
  ORDER: i18n.t('common.order'),
  PURCHASE: i18n.t('common.purchase'),
  CONSIGNMENT: i18n.t('common.consignment')
}

export const AUCTION_LANE = {
  LANE_A: 'A',
  LANE_B: 'B',
  LANE_C: 'C',
  LANE_D: 'D',
  LANE_E: 'E'
}

export const HIK_BUYER_CODE = '9999'
export const AUCTION_LANE_LIST = ['A', 'B', 'C', 'D', 'E']

export const HANDY_BUYER_INPUT_MODE = {
  BARCODE: 1,
  MANUAL: 2
}
export const DEFAULT_PER_PAGE = 25
export const FISRT_PAGE = 1

export const UNSET = '未設定'
export const PAYMENT_SITE_LIST = [UNSET, 5, 10, 15, 20, 25]

export const SIMPLE_PAYMENT_SITE_LIST = [5, 10, 15, 20, 25]

export const SALES_DATE_FILTER_TYPE = {
  MATCH_EXACT: 'match_exact',
  MATCH_AFTER: 'match_after'
}
